import React from 'react'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import MenuItem from '@mui/material/MenuItem'
import PRODUCTION_STATUS_OPTIONS from './options'
import './index.scss'

export default function ProductionStatusSelect (props) {
  const {
    id,
    value,
    defaultValue,
    disabled,
    label = 'Production status',
    name = 'productionStatus',
    className,
    onChange,
    onBlur,
  } = props
  return (
    <MuiSelectWrapper
      id={id}
      name={name}
      className={className}
      label={label}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
    >
      {PRODUCTION_STATUS_OPTIONS.map((option) => (
        <MenuItem value={option.get('value')} key={`production-status-${option.get('value')}`}>
          {option.get('label')}
        </MenuItem>
      ))}
    </MuiSelectWrapper>
  )
}
